import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { NewVersionBanner } from './NewVersionBanner';
import { useTicketEventsStream } from '../lib/use-ticket-events';

export function Layout() {
  useTicketEventsStream();
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 flex">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8">
            <Outlet />
          </div>
        </main>
      </div>
      <NewVersionBanner />
    </div>
  );
}
